<template>
<div class="accordion--container" :id="id">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
    },
}
</script>

<style>

</style>